<div class="w-100 p-3 text-uppercase text-center">
  <h3 class="mb-4 fw-bold">{{"setup_title"|translate}}</h3>
  <div class="row">
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3 position-relative"
      (click)="sharedService.pwaInstall('/assets/manifest.webmanifest')" role="button">
      <img src="/assets/logo.png" class="img-thumbnail" alt="{{'setup_pwa_erp'|translate}}">
      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <button class="btn btn-sm btn-primary border-0">
          <span>{{'setup_pwa_erp'|translate}}</span>
        </button>
      </div>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3 position-relative"
      (click)="sharedService.pwaInstall('/assets/manifest-attendance.webmanifest')" role="button">
      <img src="/assets/logo.png" class="img-thumbnail" alt="{{'setup_pwa_attendance'|translate}}">
      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <button class="btn btn-sm btn-primary border-0">
          <span>{{'setup_pwa_attendance'|translate}}</span>
        </button>
      </div>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3 position-relative"
      (click)="sharedService.pwaInstall('/assets/manifest-station-faceid.webmanifest')" role="button">
      <img src="/assets/logo.png" class="img-thumbnail" alt="{{'setup_pwa_attendance_station_faceid'|translate}}">
      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <button class="btn btn-sm btn-primary border-0">
          <span>{{'setup_pwa_attendance_station_faceid'|translate}}</span>
        </button>
      </div>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3 position-relative"
      (click)="sharedService.pwaInstall('/assets/manifest-station-qrcode.webmanifest')" role="button">
      <img src="/assets/logo.png" class="img-thumbnail" alt="{{'setup_pwa_attendance_station_qrcode'|translate}}">
      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <button class="btn btn-sm btn-primary border-0">
          <span>{{'setup_pwa_attendance_station_qrcode'|translate}}</span>
        </button>
      </div>
    </div>
    <div class="col-6 col-md-4 col-lg-3 col-xl-2 mb-3 position-relative"
      (click)="sharedService.pwaInstall('/assets/manifest-chat.webmanifest')" role="button">
      <img src="/assets/logo.png" class="img-thumbnail" alt="{{'setup_pwa_chat'|translate}}">
      <div class="position-absolute top-0 start-0 w-100 h-100 d-flex justify-content-center align-items-center">
        <button class="btn btn-sm btn-primary border-0">
          <span>{{'setup_pwa_chat'|translate}}</span>
        </button>
      </div>
    </div>
  </div>
</div>
